import { Component, OnInit } from '@angular/core';
import { Articoli } from 'src/app/models/articoli';
import { FormArticoloComponent } from 'src/app/shared/components/articoli/form-articolo/form-articolo.component';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';

@Component({
  selector: 'app-articoli-new',
  templateUrl: './articoli-new.component.html',
  styleUrls: ['./articoli-new.component.scss'],
  imports: [FormArticoloComponent],
})
export class ArticoliNewComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  articolo: Articoli;

  ngOnInit() {
    this.articolo = new Articoli();
    this.articolo.attivo = true;
  }
}
